import React from 'react';
import { FiInbox } from 'react-icons/fi';
import Button from './Button';
import './EmptyState.css';

const EmptyState = ({ 
  icon: Icon = FiInbox,
  title = 'No data found',
  description = 'There are no items to display at the moment.',
  actionText,
  onAction,
  className = ''
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-state__icon">
        <Icon size={48} />
      </div>
      <h3 className="empty-state__title">{title}</h3>
      <p className="empty-state__description">{description}</p>
      {actionText && onAction && (
        <Button onClick={onAction} className="empty-state__action">
          {actionText}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;